import I18n from 'utils/I18n';

const MAPBOX_TOKENS = {
  DEV: 'pk.eyJ1IjoiZGV2YmlyZHMiLCJhIjoiY2wyYXR6MXExMDhiMzNjcGFieTZkOGdoeCJ9.zaQcIp7I-bWAqhYzyIvYag',
  US: 'pk.eyJ1IjoiYmlyZHN1cyIsImEiOiJjbDJrcGRsb2EwNmJhM2lxaHQwbzAzM2tpIn0.EaIFeG7Vi4bFdE6CUgyzVA',
};

const INVENTORY_LEVELS = {
  HIGH_INVENTORY: 'high_inventory',
  LOW_INVENTORY: 'low_inventory',
  NO_INVENTORY: 'no_inventory',
};

const INVENTORY_LABELS = {
  high_inventory: I18n.localize('pdp.storeInventory.inStock'),
  low_inventory: I18n.localize('pdp.storeInventory.onlyFewLeft'),
  no_inventory: I18n.localize('pdp.storeInventory.soldOut'),
};

export { MAPBOX_TOKENS, INVENTORY_LEVELS, INVENTORY_LABELS };
